import { asyncLoad } from '@util'
const AsynHotspot = asyncLoad(() =>
  import('@components/LocalMerchant/VR/Detail/Hotspot')
)
export default {
  path: 'hotspot',
  component: AsynHotspot,
  stat: 'VR全景管理/基础'
}
